"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classcaded = void 0;
exports.classcaded = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(function (truthy) { return truthy; }).join(' ');
};
//# sourceMappingURL=classcaded.js.map